import { Button, Col, Descriptions, Modal, Row } from 'antd';
import React, { useState } from 'react';
import PartnerInfo from '../../components/Partner/Info';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import VehiclePartnerApi from '../../functions/api/partner/VehiclePartner';
import MyUtil from '../../functions/MyUtil';

export default function ButtonView(props) {
  const [vehiclePartner, setVehiclePartner] = useState();
  const [partner, setPartner] = useState();
  const [isOpen, setOpen] = useState(false);

  const isCar = props.vehiclePartner.vhc_modl_id ? true : false;

  async function toggleModal() {
    if (!isOpen) {
      setVehiclePartner(
        await VehiclePartnerApi.getDetailVehicle(
          props.vehiclePartner.vhc_part_id
        )
      );
      setPartner(
        await PartnerApi.getDetailPartner(props.vehiclePartner.part_id)
      );
    }

    setOpen(!isOpen);
  }

  return (
    <>
      <Button size="small" onClick={toggleModal}>
        <i className="fas fa-info"></i>
      </Button>
      {vehiclePartner && partner && (
        <Modal
          visible={isOpen}
          title={vehiclePartner.vhc_part_name}
          onCancel={toggleModal}
          onOk={toggleModal}
          width="80vw"
        >
          <Row gutter={32}>
            <Col span={6}>
              <Descriptions column={1} title={null} bordered size="small">
                {isCar && (
                  <Descriptions.Item label="Số chỗ">
                    {vehiclePartner['vhc_seat_num']}
                  </Descriptions.Item>
                )}
                {isCar && (
                  <Descriptions.Item label="Kiểu dáng">
                    {vehiclePartner['vhc_dgn_name']}
                  </Descriptions.Item>
                )}
                <Descriptions.Item label="Hộp số">
                  {vehiclePartner['vhc_tms_name']}
                </Descriptions.Item>
                <Descriptions.Item label="Xi lanh">
                  {vehiclePartner['vhc_egin_num']}
                </Descriptions.Item>
                <Descriptions.Item label="Giá cơ bản">
                  {MyUtil.currencyFormat(vehiclePartner['vhc_part_defa_prie'])}
                </Descriptions.Item>
              </Descriptions>

              <Descriptions column={1} title="Giá" bordered size="small">
                <Descriptions.Item label="2h">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_2hours']
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="4h">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_4hours']
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="8h">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_8hours']
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="12h">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_12hours']
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="24h">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_24hours']
                  )}
                </Descriptions.Item>
              </Descriptions>
              <Descriptions title="Giá" bordered column={1} size="small">
                <Descriptions.Item label="Tuần" className="text-right">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_week']
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="2 tuần" className="text-right">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_2week']
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Tháng" className="text-right">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_month']
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Quý" className="text-right">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_quarter']
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Nửa năm" className="text-right">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_halfyear']
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Năm" className="text-right">
                  {MyUtil.currencyFormat(
                    vehiclePartner['vhc_partner_price_year']
                  )}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={18}>
              <PartnerInfo.Basic partner={partner} />
              <PartnerInfo.PriceAndFee partner={partner} />
              <div className="row mt-3">
                <div className="col-6">
                  <PartnerInfo.Procedure partner={partner} />
                </div>
                <div className="col-6">
                  <PartnerInfo.Policy partner={partner} />
                </div>
              </div>
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
}
